import reducer from "./reducer";
export { default as loans } from "./components/index";
export { default as loansReducerName } from "./constants";
export default reducer;
